/* eslint-disable max-len */
import React from 'react';
import { Text, Radio, Flex, TextArea } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import classes from './TheftRecovery.css';
import Loading from "../../../../../components/Loading.js";
import TRFormDialog from "./TRFormDialog.js";
import { deactivate } from "../../../../util/TheftRecovery.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t
} = I18N.ns('recovrGeneric.assetIndustryName');
export default class DisableDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      reason: null,
      notes: null,
      loading: false
    };
  }
  onDisable = async () => {
    const {
      sharedProps: {
        item,
        actions
      },
      onClose
    } = this.props;
    const {
      reason,
      notes
    } = this.state;
    await deactivate({
      asset: item,
      assetId: item?.id,
      actions,
      closeReason: reason,
      closeNotes: notes,
      onChange: this.onLoading,
      onClose
    });
  };
  onChange = ({
    data
  }) => {
    const {
      value
    } = data;
    this.setState({
      reason: value
    });
  };
  onLoading = ({
    data,
    value
  }) => {
    this.setState({
      [data]: value
    });
  };
  getLoadingScreen() {
    return /*#__PURE__*/_jsx(Loading, {
      message: "Deactivating Theft Recovery",
      loading: true
    });
  }
  render() {
    const {
      show,
      onClose,
      type = 'end',
      title = 'Deactivate Theft Recovery Mode',
      okay = 'Yes, Deactivate Theft Recovery',
      cancel = 'No, Keep Theft Recovery Active'
    } = this.props;
    const {
      reason,
      notes,
      loading
    } = this.state;
    const uiName = process.env.UI_NAME;
    const assetIndustryName = t(uiName, 'Asset');
    const options = [{
      label: `Yes, the ${assetIndustryName} was recovered.`,
      value: 'recovered'
    }, {
      label: `No, the ${assetIndustryName} wasn't recovered.`,
      value: 'notRecovered'
    }, {
      label: `The ${assetIndustryName} was not stolen.`,
      value: 'notStolen'
    }];
    return /*#__PURE__*/_jsx(TRFormDialog, {
      show: show,
      okayDisabled: type === 'end' && reason == null || loading,
      onOkay: this.onDisable,
      onClose: onClose,
      title: title,
      okay: okay,
      cancel: cancel,
      children: /*#__PURE__*/_jsxs(Flex, {
        variant: "colM",
        children: [loading && this.getLoadingScreen(), type === 'end' ? /*#__PURE__*/_jsxs(React.Fragment, {
          children: [/*#__PURE__*/_jsxs(Flex, {
            variant: "colM",
            children: [/*#__PURE__*/_jsx(Text, {
              className: classes.trText,
              variant: "theftRecoveryPrimaryAlert",
              children: "Deactivating Theft Recovery Mode will discontinue real time tracking of your locator device."
            }), /*#__PURE__*/_jsxs(Text, {
              style: {
                paddingBottom: '8px',
                marginTop: '8px'
              },
              children: ["Did you successfully recover your stolen ", assetIndustryName, "?"]
            }), options.map(opt => /*#__PURE__*/_jsx(Radio, {
              // variant="theftRecovery"
              variant: "inputCaption",
              className: classes.radioButton,
              eventData: opt,
              label: opt.label,
              on: opt.value,
              value: reason,
              onChange: this.onChange
            }, opt.value))]
          }), /*#__PURE__*/_jsxs(Flex, {
            variant: "colM",
            style: {
              gap: '2px'
            },
            children: [/*#__PURE__*/_jsx(Text, {
              style: {
                paddingTop: '8px',
                fontSize: '13px',
                fontWeight: 600
              },
              children: " Would you like to provide additional case notes? "
            }), /*#__PURE__*/_jsx(TextArea, {
              style: {
                height: '104px',
                resize: 'none'
              },
              name: "caseNotes",
              value: notes,
              onChange: newValObject => {
                const newVal = newValObject?.value;
                this.setState({
                  notes: newVal
                });
              }
            })]
          })]
        }) : /*#__PURE__*/_jsx(Text, {
          children: "Are you sure you want to deactivate the theft recovery mode request?"
        })]
      })
    });
  }
}